import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[valueDisplay]',
})
export class ValueDisplayDirective {
  constructor(public template: TemplateRef<any>) {
  }
}
